import AppRoutes from "./routes";

export default class Constants {
  static MOBILE_SCREEN_WIDTH: number = 768;
  static APP_TIMEZONE: any = "Asia/Dubai";
  static CUSTOMER_SUPPORT_NUMBER: string = "8000 3570 3553";
  static CUSTOMER_SUPPORT_EMAIL: string = "customer.care@thriwe.com";
  static TICKET_FILE_MAX_SIZE: number = 10; //10 MB

  static delayBookingRoutes = [
    AppRoutes.delayedBookingDetails,
    AppRoutes.facility,
    AppRoutes.facilityDetails,
  ];
  static gradientPage = [AppRoutes.history];

  static footerMarginRoutes = [
    AppRoutes.benefitDetails,
    AppRoutes.delayedBookingDetails,
    AppRoutes.paddleDetails,
    AppRoutes.facility,
    AppRoutes.historyDetail,
  ];
}
